import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createChainedFunction } from '@atc/create-chained-function';
import Select from '../Select/index.js';
import Col from '../Col';
import Row from '../Row';
function SelectRange(_ref) {
  let {
    className,
    columnProps,
    component = Select,
    inline = false,
    maxSelectProps,
    minSelectProps,
    onChange,
    options,
    ...rest
  } = _ref;
  const [state, setState] = useState({
    minOptions: [],
    maxOptions: [],
    minValue: minSelectProps.defaultValue || minSelectProps.value,
    maxValue: maxSelectProps.defaultValue || maxSelectProps.value
  });

  // allows placeholders to always be an option
  const getMinOptions = (limit, opts) => limit ? opts.filter(option => option.value ? option.value <= Number(limit) || Number(limit) === 0 : true) : opts;

  // Allows placeholders to always be an option
  const getMaxOptions = (limit, opts) => limit ? opts.filter(option => option.value ? option.value >= Number(limit) : true) : opts;
  const handleMaxValueChange = event => {
    const maxValue = event.target.value;
    setState({
      ...state,
      maxValue,
      minOptions: getMinOptions(maxValue, options)
    });
  };
  const handleMinValueChange = event => {
    const minValue = event.target.value;
    setState({
      ...state,
      minValue,
      maxOptions: getMaxOptions(minValue, options)
    });
  };
  useEffect(() => {
    const setOptionsState = (minValue, maxValue, opts) => {
      setState({
        minValue,
        maxValue,
        minOptions: getMinOptions(maxValue, opts),
        maxOptions: getMaxOptions(minValue, opts)
      });
    };
    setOptionsState(minSelectProps.value, maxSelectProps.value, options);
  }, [minSelectProps.value, maxSelectProps.value, options]);
  const renderSelects = () => [minSelectProps, maxSelectProps].map((props, index) => {
    const {
      value: defaultValue,
      ...selectProps
    } = props;
    let selectValue = defaultValue;
    let handleValueChange;
    let selectOptions;
    if (index === 0) {
      selectValue = state.minValue;
      handleValueChange = handleMinValueChange;
      selectOptions = state.minOptions;
    } else {
      selectValue = state.maxValue;
      handleValueChange = handleMaxValueChange;
      selectOptions = state.maxOptions;
    }
    const selectElement = /*#__PURE__*/React.createElement(component, {
      key: index,
      value: selectValue,
      options: selectOptions,
      onChange: createChainedFunction(handleValueChange, onChange),
      ...selectProps
    });
    return inline ? /*#__PURE__*/React.createElement(Col, Object.assign({
      key: `select-element-${index}`
    }, columnProps), selectElement) : selectElement;
  });
  const ContainerComponent = inline ? Row : 'div';
  return /*#__PURE__*/React.createElement(ContainerComponent, Object.assign({
    "data-cmp": "selectRange",
    className: className
  }, rest), renderSelects());
}
export default SelectRange;